// eslint-disable-next-line no-unused-vars
import { StatsState } from './modules/statspro/types';

/**
 * @typedef {object} ReduxState
 * @property {{[key: string]: object, list: object[]}} competitions
 * @property {{[key: string]: object, list: object[]}} seasons
 * @property {{[key: string]: object, list: object[]}} rounds
 * @property {StatsState} statspro
 */

/**
 * @typedef {( any ) => Action} ActionCreator
 */

/**
 * @typedef {object} SignalActionObject
 * @property {string} REQUEST
 * @property {string} SUCCESS
 * @property {string} FAILURE
 * @property {ActionCreator} request
 * @property {ActionCreator} success
 * @property {ActionCreator} failure
 */

/**
 * @typedef {object} Action
 * @property {string} type
 * @property {any} payload
 */